import Vue from 'vue'

export var globalConf = new Vue({
    data: {
        //hostlink: 'http://localhost/',
        hostlink: 'http://demo.benchmarkpro.it/api/',
        gmaps: 'AIzaSyAXNtsKR3l4qB9TLV09jzwCd9vSppuR1lY',
        valid_type_addr: [
            "street_address",
            "premise",
            "point_of_interest",
            "establishment",
            "hospital",
            "subpremise"
        ]
    }
})